import { useIntl } from "react-intl"
import React from 'react';
import { useRef, useState, useEffect } from "react"
import { Combobox, InputDate, Modal, InputTextCustom } from "medere-ui-framework"
import { getPatientTransferRequestList, acceptPatientTransfer, finishOrReturnToPendingPatientTransfer, sendTokenToServer, cancelTransferWithoutFinish, getPhones, saveAssociatedPhone, getPhoneByUser, isAllowedToAssignTransfers, getStretcherBearers, getCancellationReasons, saveTransferFromPatientDate, hasTransferDateFromPatient, hasTaskMessageSenderPermission, getLoguedUserId } from "../services/TransferController"
import { Button } from "primereact/button";
import { Toast, ToastMessage } from 'primereact/toast';
import { getToken } from "firebase/messaging";
import { messaging, onMessageListener } from "../App";
import { HttpStatusCode } from "axios"
import { onMessage } from "firebase/messaging";
import { TransferRequestCard } from "../components/InfoCard/TransferRequestCard";
import { format } from 'date-fns';
import { Icon } from '@iconify/react';
import { MultiSelect } from "primereact/multiselect";

export enum TransferStatus {
    PENDING = 1,
    INPROGRESS = 2,
    FINISHED = 3,
    CANCELLED = 4
}

export type StatusList = {
    id: number,
    label: string,
    variable: string,
}

export enum Priority {
    URGENT = 1,
    NORMAL = 2,
}

export enum CancellationReason {
    PATIENTNOTINCONDITIONS = 1,
    PATIENTNOTFOUND = 2,
    ADMINISTRATIVEERROR = 3,
    CANCELLEDBYSOLICITANT = 4,
    NECESSARYEQUIPMENTNOTAVAILABLE = 5,
    PATIENTREFUSED = 6,
    OTHERREASONS = 7,

}

export default function StretcherBearerView() {

    
    /* const vapidKey: string | null = searchParams.get('vapidKey'); */
    const [vapidKey, setVapidKey] = useState<string | undefined>();
    const [userId, setUserId] = useState<number>(0);
    useEffect(() => {
        //TODO maxi: traer los datos de la API
        setVapidKey('');
        getLoguedUserId().then(res => {
            console.log("UserId fetched: ", res)
            setUserId(res)
        })
    }, []);
    const intl = useIntl();
    const toast = useRef(null);
    const [fromDate, setFromDate] = useState(generateFromDate())
    const [toDate, setToDate] = useState(generateToDate())
    const todayDate = new Date()
    const maxDate = new Date(todayDate);
    maxDate.setDate(maxDate.getDate() + 1);
    const [recordStatus, setRecordStatus] = useState<number>();
    const [open, setOpen] = useState(false)
    const [patienttransfer, setPatienttransfer] = useState<number>();
    const [loading, setLoading] = useState(false);
    const [returnToPendingConfirmation, setReturnToPendingConfirmation] = useState(false);
    const [cancelWithoutFinishConfirmation, setCancelWithoutFinishConfirmation] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [selectedPhone, setSelectedPhone] = useState<any>();
    const [labelPhone, setLabelPhone] = useState<any>();
    const [openPhoneWindow, setOpenPhoneWindow] = useState(false)
    const [isNotificationDisabled, setIsNotificationDisabled] = useState(false);
    const isAndroid = /Android/i.test(navigator.userAgent); //devuelve true o false
    const isIPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const [transferRequests, setTransferRequests] = useState([]);
    const [selectedTransferRequest, setSelectedTransferRequest] = useState<PatientTransferDTO>();
    let groupedByDate;
    if (transferRequests)
        groupedByDate = groupByDate(transferRequests);
    const [userAllowedToAssignUnassign, setUserAllowedToAssignUnassign] = useState(false);
    const [selectedStretcherBearer, setSelectedStretcherBearer] = useState<StretcherBearer>();
    const [userStretcherBearer, setUserStretcherBearer] = useState<number>();
    const [selectedCancellationReason, setSelectedCancellationReason] = useState<CancellationReason>();
    const [cancellationReason, setCancellationReason] = useState<string>("");
    const [returnTransferReason, setReturnTransferReason] = useState<string>("");
    const [errorSelecCanReas, setErrorSelecCanReas] = useState(false);
    const [errorTextCanReas, setErrorTextCanReas] = useState(false);
    const [openWindowConfirmationFinalization, setOpenWindowConfirmationFinalization] = useState(false);
    const [changeToSecondWindowFinalization, setChangeToSecondWindowFinalization] = useState(false);
    const [openWindowFinishTransfer, setOpenWindowFinishTransfer] = useState(false);
    const [comments, setComments] = useState('');
    const [errorStretBearer, setErrorStretBearer] = useState(false);
    const [siteAllowedToReceiveWhatsappMessages, setSiteAllowedToReceiveWhatsappMessages] = useState(false);
    const transferStatusList = [
        {
            id: 1,
            label: intl.formatMessage({ id: 'Pending' }),
            variable: "PENDING"
        }, {
            id: 2,
            label: intl.formatMessage({ id: 'InProgress' }),
            variable: "INPROGRESS",
        }, {
            id: 3,
            label: intl.formatMessage({ id: 'Finished' }),
            variable: "FINISHED",
        }, {
            id: 4,
            label: intl.formatMessage({ id: 'Cancelled' }),
            variable: "CANCELLED",
        }
    ]
    const initMultiStatus = [
        {
            id: 1,
            label: intl.formatMessage({ id: 'Pending' }),
            variable: "PENDING"
        }, {
            id: 2,
            label: intl.formatMessage({ id: 'InProgress' }),
            variable: "INPROGRESS",
        }
    ]
    const [selectedMultiStatus, setSelectedMultiStatus] = useState<StatusList[]>(initMultiStatus);

    const protocolo = window.location.protocol;
    const dominio = window.location.hostname;
    const urlBase = `${protocolo}//${dominio}`;

    onMessageListener()
    .then((payload) => {
            console.log('onMessage received. ', payload);
            reloadTransferCard();
    }).catch((err) => console.log('failed: ', err));

    onMessage(messaging, (payload) => {
        console.log("onMessage received, payload: ", payload)
        reloadTransferCard();
    });

    useEffect(() => {
        navigator.serviceWorker.register(`${urlBase}/firebase/firebase-messaging-sw.js`) //poner ${urlBase}:8080 para probar en dev
        .then((registration) => {
            console.log("se registro el service worker", registration)
            requestNotificationPermission(registration)
        })
        .catch((error) => {
            console.error('Service worker registration failed:', error);
        });
        /*navigator.serviceWorker.register(`/firebase-messaging-sw.js`) //para testear local
        .then((registration) => {
            console.log("se registro el service worker", registration)
            requestNotificationPermission(registration)
        })
        .catch((error) => {
            console.error('Service worker registration failed:', error);
        });*/
    }, []);

    function requestNotificationPermission(registration: ServiceWorkerRegistration) {
        console.log('Requesting permission...');
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                console.log('Notification permission granted.');
                getTokenAndSendToServer(registration);
            }else {
                console.log('El usuario denegó el permiso para notificaciones.');
                setIsNotificationDisabled(true)
            }
        })
    }
                
    function getTokenAndSendToServer(registration: ServiceWorkerRegistration) {
        getToken(messaging, {vapidKey: vapidKey, serviceWorkerRegistration: registration}).then((currentToken) => {
            if (currentToken) {
                sendTokenToServer(currentToken)
                .then((msgError: { statusCode: number }) => {
                    if (msgError.statusCode == 208){
                        showMessage("Error al guardar el token", toast, 'error')
                    }else{
                        console.log("Se guardo el token")
                    }    
                })
                .catch((error: any) => {
                    console.error('Error al guardar los datos:', error);
                }).finally(()=>{
                    reloadTransferCard();
                })
            } else {
                console.log('No registration token available. Request permission to generate one.');
                showMessage("No registration token available. Request permission to generate one.", toast, 'error')
            }
        }).catch((err:any) => {
            console.log('An error occurred while retrieving token. ', err);
        });
    }

    function searchInSelectedMultiStatus(id: number) {
        return selectedMultiStatus?.some(status => status.id === id)
    }

    function reloadTransferCard() {
        let pending = searchInSelectedMultiStatus(1)
        let inProgress = searchInSelectedMultiStatus(2)
        let finished = searchInSelectedMultiStatus(3)
        let cancelled = searchInSelectedMultiStatus(4)
        console.log("pending: ", pending)
        console.log("inProgress: ", inProgress)
        console.log("finished: ", finished)
        console.log("cancelled: ", cancelled)

        getPatientTransferRequestList(fromDate, toDate, pending? 1:-1, inProgress? 2:-1, finished? 3:-1, cancelled? 4:-1)
        .then((response)=>{
            setTransferRequests(response);
        }).catch((error) => {
            console.error('Error en getPatientTransferRequestList: ', error);
        })
    }

    function hasPatientTransferDateFromPatient(patienttransfer: number) {
        if (patienttransfer)
            hasTransferDateFromPatient(patienttransfer)
            .then((response)=>{
                setOpenWindowFinishTransfer(response.statusCode == 200? true: false);
            }).catch((error) => {
                console.error('Error en hasPatientTransferDateFromPatient: ', error);
            })
        else
            console.log("patienttransfer undefined in hasTransferDateFromPatient()")
    }

    function saveImWithPatientDate() {
        console.log("Entre a saveImWithPatientDate(), patienttransfer: ", patienttransfer)
        if (patienttransfer){
            saveTransferFromPatientDate(patienttransfer)
            .then((response)=>{
                console.log("TrasferFromPatientDate: ", response)
            }).catch((error) => {
                console.error('Error en saveTransferFromPatientDate: ', error);
            })
        }else{
            console.log("patienttransfer undefined in saveImWithPatientDate()")
        }  
    }

    useEffect(() => {
        if (transferRequests)
            groupedByDate = groupByDate(transferRequests);
    }, [transferRequests]);

    useEffect(() => {
      console.log("selectedTransferRequest: ", selectedTransferRequest)
    }, [selectedTransferRequest]);

    useEffect(() => {
        if (selectedCancellationReason)
            setErrorSelecCanReas(false)
        if (selectedCancellationReason && selectedCancellationReason.cancellationreason !== CancellationReason.OTHERREASONS)
            setErrorTextCanReas(false)
    }, [selectedCancellationReason]);

    useEffect(() => {
        setSelectedStretcherBearer(undefined)
    }, [open]);

    useEffect(() => {
        reloadTransferCard()
    }, [fromDate, toDate, selectedMultiStatus]);

    useEffect(() => {
        getPhoneByUser(userId).then((response)=>{
            setLabelPhone(response)
        })
    }, []);

    useEffect(() => {
        //TODO revisar que funcione en el back
        isAllowedToAssignTransfers(59).then((response)=>{   //59 es el MenuItemAction que permite asignar y desasignar camilleros a traslados
            setUserAllowedToAssignUnassign(response.statusCode == 200? true: false)
        })
        //TODO revisar lógica
        hasTaskMessageSenderPermission(9).then((response)=>{   //59 es el MenuItemAction que permite asignar y desasignar camilleros a traslados
            setSiteAllowedToReceiveWhatsappMessages(response.statusCode == 200? true: false)
        })
    }, []);

    const showMessage = (msg: any, ref: React.RefObject<Toast>, severity: ToastMessage['severity']) => {
        ref.current?.show({ severity: severity, summary: msg, life: 3000 });
    };

    type PatientTransferDTO = { patienttransfer: number, fullname: string, stretcherbearername: string, namenewsector: string, namecurrentsector: string, newsector: number, currentsector: number, conveyance: string, oxygen: boolean, medereentity: number, priority: number, prioritydescription: string, currentstatus: number, transfertodate: Date, observations: string, toroomnumber: string, tobednumber: string, fromroomnumber: string, frombednumber: string, clinichistoryid: string, userfullname: string, _userstretbearer: number}
    //type TransferStatus = { transferstatus: number, description: string }
    type StretcherBearer = { _userstretbearer: number, stretbearerfullname: string }
    type CancellationReason = {cancellationreasonI18n: number, description: string, cancellationreason: number}

    function handleClick(record: PatientTransferDTO) {
        const { patienttransfer, currentstatus, _userstretbearer } = record
        if (currentstatus !== TransferStatus.CANCELLED && currentstatus !== TransferStatus.FINISHED){
            setPatienttransfer(patienttransfer)
            setRecordStatus(currentstatus)
            setUserStretcherBearer(_userstretbearer)
            setErrorSelecCanReas(false)
            setErrorTextCanReas(false)
            setErrorStretBearer(false)
            setOpen(true)
            setOpenWindowFinishTransfer(false)
            hasPatientTransferDateFromPatient(patienttransfer)
            setSelectedTransferRequest(record)
        }

    }

    function handleCancellationReasonChange(event: any) {
        setCancellationReason(event.target.value);
        if (cancellationReason && cancellationReason != "")
            setErrorTextCanReas(false)
    }

    function handleReturnReasonChange(e: any) {
        setReturnTransferReason(e.target.value);
    }


    function handleCommentChange(event: any) {
        setComments(event.target.value);
    }

    function changeShowFilters() {
        showFilters ? setShowFilters(false) : setShowFilters(true)
    }

    function generateFromDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    function generateToDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    function accept() {
        setLoading(true)
        if (!selectedStretcherBearer){
            setErrorStretBearer(true)
          }
        if (patienttransfer && (userAllowedToAssignUnassign? selectedStretcherBearer:userId)) {
            if (recordStatus === TransferStatus.PENDING){
                acceptPatientTransfer(patienttransfer, userAllowedToAssignUnassign? selectedStretcherBearer?._userstretbearer : userId)
                .then((response: { statusCode: number }) => {
                    if (response.statusCode == HttpStatusCode.Conflict){
                        showMessage(intl.formatMessage({ id: 'TransferAlreadyInProgress' }), toast, 'error')
                    }
                    //setOpen(false);
                    setRecordStatus(TransferStatus.INPROGRESS)
                    setUserStretcherBearer(userAllowedToAssignUnassign? selectedStretcherBearer?._userstretbearer:userId)
                    selectedTransferRequest && selectedTransferRequest.currentstatus && selectedTransferRequest.currentstatus != 2? selectedTransferRequest.currentstatus = 2: selectedTransferRequest?.currentstatus
                })
                .catch((error: any) => {
                    console.error('Error al guardar los datos:', error);
                }).finally(()=>{
                    reloadTransferCard()
                })
            }
        }else{
            console.error('pattienttransfer or userId undefined');
        }
        setLoading(false)
    }

    function finish(){
        setLoading(true)
        if (patienttransfer && userStretcherBearer){
            finishOrReturnToPendingPatientTransfer(patienttransfer, userStretcherBearer, true, comments)
            .then((msgError: { statusCode: number }) => {
                if (msgError.statusCode == 208){
                    showMessage(intl.formatMessage({ id: 'YouCantCancelOrFinishIfNotYourTransfer'}), toast, 'error')
                }
                setOpen(false);
                setChangeToSecondWindowFinalization(true)
                setComments("")
            })
            .catch((error: any) => {
                console.error('Error al guardar los datos:', error);
            }).finally(()=>{
                reloadTransferCard()
            })
        }else{
            console.log("patienttransfer or userStretcherBearer undefined")
        }
        setLoading(false)
    }

    function returnToPending() {
        setLoading(true)
        if (patienttransfer && userStretcherBearer){
            finishOrReturnToPendingPatientTransfer(patienttransfer, userStretcherBearer, false, "")
            .then((msgError: { statusCode: number }) => {
                if (msgError.statusCode == 208){
                    showMessage(intl.formatMessage({ id: 'YouCantCancelOrFinishIfNotYourTransfer'}), toast, 'error')
                }else{
                    showMessage(intl.formatMessage({ id: 'TransferReturnedToPending' }), toast, 'success')
                }
                setOpen(false);
                setReturnToPendingConfirmation(false)
            })
            .catch((error: any) => {
                console.error('Error al guardar los datos:', error);
            }).finally(()=>{
                reloadTransferCard()
            })
        }else{
            console.log("patienttransfer or userStretcherBearer undefined")
        }
        setLoading(false)
    }

    function cancelTransfer() {
        if (!selectedCancellationReason){
            setErrorSelecCanReas(true)
        }
        if(selectedCancellationReason && selectedCancellationReason.cancellationreason === CancellationReason.OTHERREASONS && !cancellationReason){
            setErrorTextCanReas(true)
        }
        setLoading(true)
        if (patienttransfer && userStretcherBearer && selectedCancellationReason && (selectedCancellationReason.cancellationreason === CancellationReason.OTHERREASONS? cancellationReason:true)){
            cancelTransferWithoutFinish(patienttransfer, userStretcherBearer, selectedCancellationReason.cancellationreason, cancellationReason)
            .then((msgError: { statusCode: number }) => {
                if (msgError.statusCode == 208){
                    showMessage(intl.formatMessage({ id: 'YouCantCancelOrFinishIfNotYourTransfer'}), toast, 'error')
                }else{
                    showMessage(intl.formatMessage({ id: 'TransferPatientCancelled' }), toast, 'success')
                }
                setOpen(false);
                setCancelWithoutFinishConfirmation(false)
                setSelectedCancellationReason(undefined)
                setCancellationReason("")
            })
            .catch((error: any) => {
                console.error('Error al guardar los datos:', error);
            }).finally(()=>{
                reloadTransferCard()
            })
        }else{
            console.log("patienttransfer or userStretcherBearer or selectedCancellationReason undefined")
        }
        setLoading(false)
    }

    function refresh() {
        reloadTransferCard()
    }

    function changeAssociatedPhone() {
        setLoading(true)
        console.log("id: ", selectedPhone.stretcherbearerphone)
        const stretcherbearerphone = selectedPhone.stretcherbearerphone;
        if (stretcherbearerphone && userId) {
           saveAssociatedPhone(stretcherbearerphone)
            .then((msgError) => {
                if (msgError.statusCode == 500){
                    showMessage("Internal Error", toast, 'error')
                }else{
                    showMessage(intl.formatMessage({ id: 'TheOperationWasSuccessful' }), toast, 'success')
                    getPhoneByUser(userId).then((response)=>{
                        setLabelPhone(response)
                        console.log("response phone: ", response)
                        console.log("phone 2: ", labelPhone)
                    })
                }
            })
            .catch(error => {
                console.error('Error al guardar los datos:', error);
            })
            
        }else{
            console.error('stretcherbearerphone or userId undefined');
        }
        setOpenPhoneWindow(false)
        setLoading(false)
    }

    function groupByDate(transferRequests: any[]) {
        if (transferRequests){
            const groupedByDate:any = {};
      
            transferRequests.forEach((record) => {
              const dateKey = new Date(record.requestedtime).toLocaleDateString('en-CA');
              if (!groupedByDate[dateKey]) {
                groupedByDate[dateKey] = [];
              }
              groupedByDate[dateKey].push(record);
            });
          
            const sortedDates = Object.keys(groupedByDate).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
          
            const sortedGroupedByDate:any = {};
            sortedDates.forEach((date) => {
              sortedGroupedByDate[date] = groupedByDate[date];
            });
          
            return sortedGroupedByDate;
        }else{
            return null;
        }
    }
    

    return (
        <div className="m-4 viewContainer">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 className="text-2xl" style={{lineHeight:'24px', color: '#B67345', fontWeight: 600}}>{intl.formatMessage({id:'Patients'})+' / '+intl.formatMessage({ id: 'PatientTransfers' })}</h2>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button icon='pi pi-refresh' onClick={() => refresh()} style={{ color: '#14C7BC', background: '#F4F4F4', marginTop: '15px', marginBottom: '5px', border: 'none', borderRadius: '4px', fontSize:'15px' }}></Button>
                    <Button className='size-icon-button' icon='pi pi-sliders-v' onClick={() => changeShowFilters()} style={{ marginLeft:'6px', marginTop: '15px', marginBottom: '5px', background: '#F4F4F4', border: 'none', color: '#14C7BC', borderRadius: '4px', fontSize:'12px' }}></Button>
                </div>
            </div>
            {showFilters && (<div className="flex md:gap-4 gap-2 items-end flex-col md:flex-row">
                <div className="md:pb-2 md:pt:2 pt-4 w-full">
                    <label htmlFor="statusList" style={{ marginBottom: '4px', fontSize: '16px', fontWeight: 500, color: '#595E6C', display: 'block' }}>
                        {intl.formatMessage({ id: 'Status' })}
                    </label>
                    <MultiSelect style={{marginBottom: '3px'}} display="chip" inputId="statusList" options={transferStatusList} optionLabel="label" placeholder="" value={selectedMultiStatus} onChange={(e) => setSelectedMultiStatus(e.value)}/>
                </div>
                <InputDate label={intl.formatMessage({ id: 'from' })} value={fromDate} onChange={(e: any) => setFromDate(e.value)} maxDate={todayDate} />
                <InputDate label={intl.formatMessage({ id: 'to' })} value={toDate} onChange={(e: any) => setToDate(e.value)} maxDate={maxDate} />
            </div>)}

            {transferRequests && (<div style={{paddingLeft: '0px'}} className="cards-container transfer-requests-container">
                {Object.entries(groupedByDate).map(([date, records]:any) => {
                    const dateObj = new Date(date);
                    dateObj.setDate(dateObj.getDate() + 1);
                    return (
                      <div key={date}>
                        <h2 className="fontSize23" style={{ color: '#B67345' }}>{format(dateObj, 'dd/MM/yyyy')}</h2>
                        {records.map((record:PatientTransferDTO) => (
                          <TransferRequestCard
                            key={record.patienttransfer}
                            record={record}
                            handleClick={handleClick}
                            userId={userId}
                            userAllowedToAssignUnassign={userAllowedToAssignUnassign}
                          />
                        ))}
                      </div>
                    );
                  })
                }
            </div>)}

            {!transferRequests && (
                <div style={{border: '1px solid #ccc'}} className="cards-container">
                    <h1>{intl.formatMessage({ id: 'ThereAreNoPendingTransferRequestsCurrently' })}</h1>
                </div>
            )}

            <Modal visible={open} setVisible={setOpen} className="custom-modal" header={recordStatus === TransferStatus.INPROGRESS ?<span> {intl.formatMessage({ id: 'YouStartedThisTransfer' })} </span> : <span>{intl.formatMessage({ id: 'YouAreAboutToTakeThisTransfer...' })}</span>} onClickLeftBtn={() => recordStatus === TransferStatus.INPROGRESS ? '':setOpen(false)} footerButtonLeftText={loading ? intl.formatMessage({ id: 'Loading...' }):(recordStatus === TransferStatus.INPROGRESS ? '' : intl.formatMessage({ id: 'Decline' }))} onClickRightBtn={() => recordStatus === TransferStatus.INPROGRESS ? '':accept()} footerButtonRightText={loading ? intl.formatMessage({ id: 'Loading...' }):(recordStatus === TransferStatus.INPROGRESS ? '' : intl.formatMessage({ id: 'CONFIRM' }))}>
                <div className="flex flex-col gap-2">
                    
                    {userAllowedToAssignUnassign && recordStatus !== TransferStatus.INPROGRESS && 
                    (<Combobox label={intl.formatMessage({id:'StretcherBearer'})} getItems={getStretcherBearers} optionLabel='stretbearerfullname' setValue={setSelectedStretcherBearer} value={selectedStretcherBearer} error={errorStretBearer} caption ={errorStretBearer? intl.formatMessage({ id: 'SelectStretcherBearer' }): ""}/>)}

                    {selectedTransferRequest && (<TransferRequestCard
                        key={selectedTransferRequest.patienttransfer}
                        record={selectedTransferRequest}
                        handleClick={handleClick}
                        userId={userId}
                        details
                        userAllowedToAssignUnassign={userAllowedToAssignUnassign}
                    />)}             

                    <div style={{ display: 'flex', justifyContent: 'center'}}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Button className='buttonMain btnCancel2 fontSizeFifteen' visible={recordStatus === TransferStatus.INPROGRESS} onClick={() => setCancelWithoutFinishConfirmation(true)} label={intl.formatMessage({ id: 'Anular' })}/>
                        </div>    
                        
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Button className='buttonMain btnReturnToPending fontSizeFifteen' visible={recordStatus === TransferStatus.INPROGRESS} onClick={() => setReturnToPendingConfirmation(true)} label={intl.formatMessage({ id: 'ReturnToPending' })}/>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Button className={`buttonMain fullWidth ${openWindowFinishTransfer ? 'darkBlueColorBackground' : ''}`} visible={recordStatus === TransferStatus.INPROGRESS} onClick={() => openWindowFinishTransfer? (setOpenWindowConfirmationFinalization(true), setOpen(false)) : (saveImWithPatientDate(), setOpenWindowFinishTransfer(true))} label={ openWindowFinishTransfer? intl.formatMessage({ id: 'FINISHTRANSFER' }) : intl.formatMessage({ id: 'StartingTransfer' })} />
                        </div>
                    </div>                      
                </div>
            </Modal>

            <Modal visible={openWindowConfirmationFinalization} setVisible={setOpenWindowConfirmationFinalization} header={changeToSecondWindowFinalization?<span style={{color: '#B67345'}}>{intl.formatMessage({ id: 'YouFinishedYourTransfer' })}</span>:<span style={{color: '#B67345'}}>{intl.formatMessage({ id: 'TransferFinished?' })}</span>} className="custom-modal" onClickLeftBtn={() => changeToSecondWindowFinalization ? '':(setOpenWindowConfirmationFinalization(false), setOpen(true))} footerButtonLeftText={loading ? intl.formatMessage({ id: 'Loading...' }):(changeToSecondWindowFinalization ? '' : intl.formatMessage({ id: 'Cancel' }))} onClickRightBtn={() => {finish()}} footerButtonRightText={loading ? intl.formatMessage({ id: 'Loading...' }):(changeToSecondWindowFinalization? '' : intl.formatMessage({ id: 'CONFIRM' }))}>
                <div className="flex flex-col gap-2">
                        {!changeToSecondWindowFinalization && (
                            <textarea className="comment-box" value={comments} onChange={handleCommentChange} placeholder={intl.formatMessage({ id: 'Comments' })+':'}/>
                        )}
                        {changeToSecondWindowFinalization && (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Icon className="largeCheckIcon" icon='bi:check' />
                                <Button
                                    className='buttonMain fullWidth'
                                    visible={changeToSecondWindowFinalization}
                                    onClick={() => { setChangeToSecondWindowFinalization(false); setOpenWindowConfirmationFinalization(false); setOpen(false) }}
                                    label={intl.formatMessage({ id: 'SEEPENDINGREQUESTS' })}
                                    style={{ width: '100%', fontSize: '20px' }}
                                />
                            </div>
                        )}
                </div>
            </Modal>

            <Modal className="custom-modal-header" visible={returnToPendingConfirmation} setVisible={setReturnToPendingConfirmation} header={intl.formatMessage({ id: 'ReturnToPending' })}>
                <InputTextCustom
                    value={returnTransferReason}
                    label={intl.formatMessage({ id: 'JustifyReturnToPendingOrCancellation' }) + ' (' +intl.formatMessage({ id: 'Optional' }) + '):'}
                    onChange={handleReturnReasonChange}
                />
                <h3 style={{ marginTop: '0', fontSize: '16px' }}>{intl.formatMessage({ id: 'TheTransferWillReturnToPendingState' })}</h3>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <Button className='buttonMain btnCancel3' style={{ marginLeft: '10px' }} onClick={() => setReturnToPendingConfirmation(false)}>{intl.formatMessage({ id: 'NoCancel' })}</Button>
                    <Button className='buttonMain' style={{ marginRight: '10px' }} onClick={() => { returnToPending() }}>{intl.formatMessage({ id: 'YesReturn' })}</Button>
                </div>
            </Modal>

            <Modal className="custom-modal-header" visible={cancelWithoutFinishConfirmation} setVisible={setCancelWithoutFinishConfirmation} header={ "¿" + intl.formatMessage({ id: 'CancelTransfer' }) + "?"}>
                
                <Combobox label={intl.formatMessage({id:'CancellationReason'})} getItems={getCancellationReasons} optionLabel='description' setValue={setSelectedCancellationReason} value={selectedCancellationReason} error={errorSelecCanReas} caption ={errorSelecCanReas? intl.formatMessage({ id: 'SelectCancellationReason' }): ""} />
                
                {selectedCancellationReason?.cancellationreason === CancellationReason.OTHERREASONS && (
                     <InputTextCustom
                        value={cancellationReason}
                        label={
                        intl.formatMessage({ id: 'DetailTheCancellationReason' }) +
                        ' (' +
                        intl.formatMessage({ id: 'Mandatory' }) +
                        ')'
                        }
                        onChange={handleCancellationReasonChange}
                        error={errorTextCanReas}
                        caption={errorTextCanReas ? intl.formatMessage({ id: 'YouMustDetailTheReason' }) : ''}
                    />
                )}

                <h3 style={{ marginTop: '0', fontSize: '16px' }}>{intl.formatMessage({ id: 'TheTransferWillNotReturnToPendingStateItWillBeCancelled' })}</h3>
                
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <Button className='buttonMain btnCancel3' style={{ marginLeft: '10px' }} onClick={() => {setCancelWithoutFinishConfirmation(false); setSelectedCancellationReason(undefined); setCancellationReason("")}}>{intl.formatMessage({ id: 'DoNotCancel' })}</Button>
                    <Button className='buttonMain' style={{ marginRight: '10px' }} onClick={() => { cancelTransfer() }}>{intl.formatMessage({ id: 'YesDecline' })}</Button>
                </div>
            </Modal>

            <Modal visible={openPhoneWindow} setVisible={setOpenPhoneWindow} header={intl.formatMessage({ id: 'PhoneSelection' })} className="custom-modal" onClickRightBtn={() => (changeAssociatedPhone())} footerButtonRightText={loading ? intl.formatMessage({ id: 'Loading...' }):intl.formatMessage({ id: 'Accept' })}>
                <div className="flex flex-col gap-2">
                    <Combobox label={intl.formatMessage({ id: 'Cellphone' })} getItems={getPhones} optionLabel='description' setValue={setSelectedPhone} value={selectedPhone} />
                </div>
            </Modal>

            <Modal visible={isNotificationDisabled} setVisible={setIsNotificationDisabled} header={intl.formatMessage({ id: 'YouDontHaveNotificationsEnabled' })} onClickRightBtn={() => setIsNotificationDisabled(false)}>
                <div style={{ margin: '10px 0', fontSize: '16px', lineHeight: '1.5' }}>
                {intl.formatMessage({ id: 'WeAskYouTo' })}:
                    <div style={{ margin: '20px', padding: '15px', border: '2px solid black' }}>
                        {isAndroid && (<p>{intl.formatMessage({ id: 'OnYourAndroidDevice' })}:</p>)}
                        {isIPhone && (<p>{intl.formatMessage({ id: 'OnYourIPhoneDevice' })}:</p>)}
                        {(isAndroid || isIPhone) && (<ol style={{ marginLeft: '20px' }}>
                            <li>1. {intl.formatMessage({ id: 'GoToSettingsOnYourDevice' })}</li>
                            <li>2. {intl.formatMessage({ id: 'GoToNotifications' })}</li>
                            <li>3. {intl.formatMessage({ id: 'EnableThemForYourNavigator' })}</li>
                        </ol>)}
                        <p>{intl.formatMessage({ id: 'IfProblemPersistTry' })}:</p>
                        <ol style={{ marginLeft: '20px' }}>
                            <li>1. {intl.formatMessage({ id: 'GoToSettingsOnYourNavigator' })}</li>
                            <li>2. {intl.formatMessage({ id: 'GoToPrivacyAndSecurity->DeleteNavigationData' })}</li>
                            <li>3. {intl.formatMessage({ id: 'DeleteYourCookiesOrCache' })}</li>
                            <li>4. {intl.formatMessage({ id: 'TryVerifyingIfSomethingIsBlockingNotificationsInNavigatorOrDevice' })}</li>
                            <li>5. {intl.formatMessage({ id: 'ToReceiveNotificationsWeRecommendDisablingIncognitoModeTryOpeningARegularTabToEnableNotificationPermissions' })}</li>
                        </ol>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <Button className='buttonMain' style={{ marginRight: '10px' }} onClick={() => setIsNotificationDisabled(false)}>
                        {intl.formatMessage({ id: 'Accept' })}
                    </Button>
                </div>
            </Modal>

            <Toast ref={toast} position="bottom-right" />

        </div>
    )
}